// import React, { useEffect, useState } from 'react';
// import Modal from 'react-modal';
// import { collection, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
// import { db } from '../config/fbConfig';
// import Loader from "./Loader";

// const AddTeacherToSubjectModal = ({ isOpen, onClose, classId, subject, currentTerm, onSuccess }) => {
//   const [teachers, setTeachers] = useState([]);
//   const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filter, setFilter] = useState('');

//   useEffect(() => {
//     if (!isOpen) return;

//     const fetchTeachers = async () => {
//       setLoading(true);
//       try {
//         const snap = await getDocs(collection(db, 'users'));
//         const allTeachers = snap.docs
//           .map(doc => ({ id: doc.id, ...doc.data() }))
//           .filter(user => ['Teacher', 'Cashier', 'Admin'].includes(user.status) && user.isActive === true);

//         const assignedTeacherIds = [];
//         for (const teacher of allTeachers) {
//           const isAssigned = teacher.teachingAssignments?.some(
//             assignment => assignment.classId === classId &&
//             assignment.subjectId === subject.id
//           );
//           if (isAssigned) {
//             assignedTeacherIds.push(teacher.id);
//           }
//         }

//         setTeachers(allTeachers);
//         setSelectedTeacherIds(assignedTeacherIds);
//       } catch (error) {
//         console.error("Error fetching teachers:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTeachers();
//   }, [isOpen, classId, subject]);

//   const handleCheckboxChange = (teacherId, isChecked) => {
//     if (isChecked) {
//       setSelectedTeacherIds(prev => [...prev, teacherId]);
//     } else {
//       setSelectedTeacherIds(prev => prev.filter(id => id !== teacherId));
//     }
//   };

//   const handleAssign = async () => {
//     setLoading(true);
//     try {
//       for (const teacher of teachers) {
//         const teacherRef = doc(db, 'users', teacher.id);
//         const teacherSnap = await getDoc(teacherRef);
//         const currentAssignments = teacherSnap.data().teachingAssignments || [];

//         const exists = currentAssignments.some(
//           a => a.classId === classId && a.subjectId === subject.id
//         );

//         const shouldBeAssigned = selectedTeacherIds.includes(teacher.id);

//         let updatedAssignments;

//         if (shouldBeAssigned && !exists) {
//           updatedAssignments = [...currentAssignments, { classId, subjectId: subject.id, termId: currentTerm.termId, sessionId: currentTerm.sessionId, }];
//           await updateDoc(teacherRef, { teachingAssignments: updatedAssignments });
//         }

//         if (!shouldBeAssigned && exists) {
//           updatedAssignments = currentAssignments.filter(
//             a => !(a.classId === classId && a.subjectId === subject.id)
//           );
//           await updateDoc(teacherRef, { teachingAssignments: updatedAssignments });
//         }
//       }

//       onSuccess();
//       onClose();
//     } catch (error) {
//       console.error("Error updating teacher assignments:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredTeachers = teachers.filter(
//     teacher =>
//       `${teacher.firstName} ${teacher.lastName}`.toLowerCase().includes(filter.toLowerCase())
//   );

//   if (!isOpen) return null;

//   return (
//     <Modal isOpen={isOpen} onRequestClose={onClose}
//       className="custom-modal"
//       overlayClassName="custom-modal-overlay"
//     >
//       <p className='size5 caps'>Assign Teacher(s) to {subject?.name}</p>

//       {loading ? (
//         <Loader text={"LOADING"} />
//       ) : (
//         <>
//           <input
//             type="text"
//             placeholder="Search by name"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             className="input-field1"
//           />

//           <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
//             {filteredTeachers.map(teacher => (
//               <label key={teacher.id} style={{ display: 'block', marginBottom: '8px' }}>
//                 <input
//                   type="checkbox"
//                   className="input-checkbox gold-tick male-female-stat"
//                   checked={selectedTeacherIds.includes(teacher.id)}
//                   onChange={(e) => handleCheckboxChange(teacher.id, e.target.checked)}
//                 />
//                 {teacher.firstName} {teacher.lastName}
//                 {selectedTeacherIds.includes(teacher.id) && (
//                   <span style={{ color: 'green', fontSize: '0.7rem' }}> (Assigned)</span>
//                 )}
//               </label>
//             ))}
//           </div>

//           <div className="row align-center gap-15" style={{ marginTop: '16px' }}>
//             <button
//               onClick={onClose}
//               className="login-button"
//               style={{ marginLeft: '8px' }}
//               disabled={loading}
//             >
//               Cancel
//             </button>
//             <button onClick={handleAssign} className="login-button" disabled={loading}>
//               {loading ? 'Processing...' : 'Save Changes'}
//             </button>
//           </div>
//         </>
//       )}
//     </Modal>
//   );
// };

// export default AddTeacherToSubjectModal;









import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { collection, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import Loader from "./Loader";

const AddTeacherToSubjectModal = ({ 
  isOpen, 
  onClose, 
  classId, 
  subject, 
  currentTerm, 
  onSuccess 
}) => {
  
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, 'users'));
        const allTeachers = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(user => ['Teacher', 'Cashier', 'Admin'].includes(user.status) && user.isActive === true);

        const assignedTeacherIds = [];
        for (const teacher of allTeachers) {
          const isAssigned = teacher.teachingAssignments?.some(
            assignment => 
              assignment.classId === classId && 
              assignment.subjectId === subject.id &&
              assignment.termId === currentTerm?.termId   // ← Important: Filter by current term
          );
          if (isAssigned) {
            assignedTeacherIds.push(teacher.id);
          }
        }

        setTeachers(allTeachers);
        setSelectedTeacherIds(assignedTeacherIds);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, [isOpen, classId, subject, currentTerm]);

  const handleAssign = async () => {
    if (!currentTerm?.termId) {
      alert("Current Term is not set. Please set the current term first.");
      return;
    }

    setLoading(true);
    try {
      for (const teacher of teachers) {
        const teacherRef = doc(db, 'users', teacher.id);
        const teacherSnap = await getDoc(teacherRef);
        let currentAssignments = teacherSnap.data().teachingAssignments || [];

        const shouldBeAssigned = selectedTeacherIds.includes(teacher.id);

        // Remove any previous assignment for this class + subject (clean old terms)
        currentAssignments = currentAssignments.filter(
          a => !(a.classId === classId && a.subjectId === subject.id)
        );

        // Add new assignment with current term info
        if (shouldBeAssigned) {
          currentAssignments.push({ 
            classId,
            subjectId: subject.id,
            termId: currentTerm.termId,
            sessionId: currentTerm.sessionId,
            periods: 2                     // Default periods
          });
        }

        await updateDoc(teacherRef, { 
          teachingAssignments: currentAssignments 
        });
      }

      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Error updating teacher assignments:", error);
      alert("Failed to save. Please check console.");
    } finally {
      setLoading(false);
    }
  };

  const filteredTeachers = teachers.filter(
    teacher =>
      `${teacher.firstName} ${teacher.lastName}`.toLowerCase().includes(filter.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <Modal 
      isOpen={isOpen} 
      onRequestClose={onClose}
      className="custom-modal"
      overlayClassName="custom-modal-overlay"
    >
      <p className='size5 caps'>
        Assign Teacher(s) to {subject?.name}
        {currentTerm && (
          <span style={{ fontSize: '0.85rem', display: 'block', marginTop: '4px', color: '#555' }}>
            {currentTerm.sessionName} - {currentTerm.termName} Term
          </span>
        )}
      </p>

      {loading ? (
        <Loader text={"LOADING"} />
      ) : (
        <>
          <input
            type="text"
            placeholder="Search by name"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="input-field1"
          />

          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {filteredTeachers.map(teacher => (
              <label key={teacher.id} style={{ display: 'block', marginBottom: '8px' }}>
                <input
                  type="checkbox"
                  className="input-checkbox gold-tick male-female-stat"
                  checked={selectedTeacherIds.includes(teacher.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedTeacherIds(prev => [...prev, teacher.id]);
                    } else {
                      setSelectedTeacherIds(prev => prev.filter(id => id !== teacher.id));
                    }
                  }}
                />
                {teacher.firstName} {teacher.lastName}
              </label>
            ))}
          </div>

          <div className="row align-center gap-15" style={{ marginTop: '16px' }}>
            <button
              onClick={onClose}
              className="login-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              onClick={handleAssign} 
              className="login-button" 
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Save Changes'}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default AddTeacherToSubjectModal;